import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { shippingService } from '../services/shipping.service';
import type { UpdateShippingRateData } from '../types/shipping.types';

interface UpdateShippingRateParams {
  refId: string;
  data: UpdateShippingRateData;
}

export function useUpdateShippingRate() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ refId, data }: UpdateShippingRateParams) =>
      shippingService.updateShippingRate(refId, data),
    onSuccess: (_, variables) => {
      toast.success(t('shipping.rateUpdated', { defaultValue: 'Shipping rate updated successfully' }));
      queryClient.invalidateQueries({ queryKey: ['shippingRates'] });
      queryClient.invalidateQueries({ queryKey: ['shippingRate', variables.refId] });
      navigate('/shipping');
    },
    onError: (error) => {
      console.error('Failed to update shipping rate:', error);
      toast.error(t('common.error', { defaultValue: 'An error occurred' }));
    },
  });
}
